// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from '@localytics/loc-components/lib/Modal';
import Button from '@localytics/loc-components/lib/Button';
import Dropdown from '@localytics/loc-components/lib/Dropdown';
import withLeaveDialog from './withLeaveDialog';
import { updateOrchestrationVersionEntryEvent } from '../actions/api';
import { getQueryParams } from '../util/RouterUtils';
import './stylesheets/EntryEventModal.scss';
import type { OrchestrationVersion } from '../constants/ApiTypes';
import type { EventMapping } from '../constants/RailsApiTypes';

type EntryEventModalProps = {
  orgId: number,
  orchestrationId: number,
  versionId: number,
  dispatch: Function,
  showModal: boolean,
  eventMappings: Array<Object>,
  eventMappingsById: Array<Object>,
  onCloseCallback: Function,
  version: OrchestrationVersion,
  currentValue: EventMapping
};

type Option = {
  label: string,
  value: number
};

type State = {
  selectedValue: Option | null
};

class EntryEventModal extends Component<EntryEventModalProps, State> {
  state = {
    selectedValue: this.props.currentValue
      ? {
          label: this.props.currentValue.name,
          value: this.props.currentValue.id
        }
      : null
  };

  setValue: Function = (option: { label: string, value: number }) => {
    this.setState({ selectedValue: option });
  };

  submitValue: Function = () => {
    const { selectedValue } = this.state;
    // This makes flow happy :/ but the submit isn't allowed until a value is selected
    if (!selectedValue) {
      return;
    }
    const eventMappingId = selectedValue.value;
    const entryEventData = this.props.eventMappingsById[eventMappingId];
    const events = entryEventData.events.map(e => ({
      name: e.name,
      olap_id: e.olap_id
    }));

    this.props.onCloseCallback();
    this.props.dispatch(
      updateOrchestrationVersionEntryEvent(
        this.props.orgId,
        this.props.orchestrationId,
        this.props.versionId,
        events,
        eventMappingId
      )
    );
  };

  focusDropdown: Function = div => {
    if (div) {
      div.getElementsByClassName('Select-input')[0].focus();
    }
  };

  entryDropdownDiv: ?HTMLDivElement;

  render() {
    const { eventMappings, version } = this.props;
    const { selectedValue } = this.state;

    let isLoading = false;
    let options = [];
    let selected = selectedValue;
    if (eventMappings && version) {
      const appIds = version.apps.map(a => a.app_uuid);

      const eventApps = eventMappings.filter(em =>
        appIds.every(appId => em.events.map(ev => ev.app_id).includes(appId))
      );

      options = eventApps
        .map(group => ({
          label: group.name,
          value: group.id
        }))
        .sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));

      if (selectedValue && !selectedValue.label) {
        selected = options.find(o => o.value === this.props.currentValue.id);
      }
    } else {
      isLoading = true;
    }
    const ModalWithLeaveDialog = withLeaveDialog(Modal);

    return (
      <ModalWithLeaveDialog
        className="EntryEventModal"
        show={this.props.showModal}
        onHide={this.props.onCloseCallback}
      >
        <div className="EntryEventModal__Content">
          <div className="EntryEventModal__Content__Title">Entry Event</div>
          <div
            className="ChooseEntryEventPage__Dropdown"
            ref={this.focusDropdown}
          >
            <Dropdown
              name="EventMapping"
              options={options}
              selectedValue={selected}
              onSelect={this.setValue}
              clearable={false}
              isLoading={isLoading}
            />
          </div>
          <div className="EntryEventModal__Content__Buttons">
            <Button
              size="large"
              label="Cancel"
              tabIndex={-1}
              onClick={this.props.onCloseCallback}
            />
            <Button
              type="primary"
              size="large"
              label="Save Changes"
              tabIndex={-1}
              onClick={this.submitValue}
              disabled={!this.state.selectedValue}
            />
          </div>
        </div>
      </ModalWithLeaveDialog>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgId, orchestrationId, versionId } = getQueryParams(
    ownProps.location
  );
  return {
    orchestrationId,
    orgId,
    eventMappingsById: state.railsApi.eventMappingsById,
    eventMappings: state.railsApi.eventMappings,
    versionId,
    version:
      state.api.versionsByOrchestrationId[orchestrationId] &&
      state.api.versionsByOrchestrationId[orchestrationId][versionId]
  };
};

export default withRouter(connect(mapStateToProps)(EntryEventModal));



// WEBPACK FOOTER //
// ./src/components/EntryEventModal.jsx